import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage';
import { LinkButton, Heading } from '../../atoms';
import { StyledLearnMoreContainer, InfoContainer, BodyText } from './styles.js';

export const LearnMore = ({
  img,
  heading,
  body,
  buttonUrl,
  buttonLabel,
  backgroundColor,
  buttonVariant,
  fontColor,
}) => {
  return (
    <StyledLearnMoreContainer
      fontColor={fontColor}
      backgroundColor={backgroundColor}
    >
      <ResponsiveImage {...img} />
      <InfoContainer>
        <Heading
          headingLevel="h3"
          typography={'heading3'}
          headingText={heading}
          position="center"
          backgroundColor={backgroundColor}
        />
        <BodyText>{body}</BodyText>
      </InfoContainer>
      <LinkButton
        verticalPadding={4}
        horizontalPadding={22}
        variant={buttonVariant}
        href={buttonUrl}
      >
        {buttonLabel}
      </LinkButton>
    </StyledLearnMoreContainer>
  );
};

LearnMore.propTypes = {
  img: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonVariant: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  fontColor: PropTypes.string.isRequired,
};
